import type { Chart } from './types';

export const getWidthMetrics = (config: Chart): string[] => {
  if (!('leftAxisSeries' in config)) {
    return [];
  }

  const widthMetrics = [
    config.leftAxisSeries?.lineWidthMetric,
    config.rightAxisSeries?.lineWidthMetric,
  ].filter((metric): metric is string => {
    return !!metric;
  });

  return [...new Set(widthMetrics)].sort();
};
